import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "client-info__fields ml-6" }
const _hoisted_3 = { class: "client-info__fields-name" }
const _hoisted_4 = { class: "d-block mt-2" }

import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import AppCardInfo from '@/components/App/AppCardInfo.vue';
import { getStorageFile } from '@/utils/S3StorageUtils';
import { Utils } from '@/utils/index';
import { IBusinessInfo } from '@/types/store';

// #contants

export default /*@__PURE__*/_defineComponent({
  __name: 'BidViewCorporateClient',
  setup(__props) {

const { getters } = useStore();

// #data
const file = ref<string | null | undefined>(null);

// #computed
const businessInfo = computed<IBusinessInfo>(() => {
  return getters['getBusinessInfo'];
});
const getLogo = computed<string>(() => {
  const {
    owner = {
      company: {
        logo: {
          url: ''
        }
      }
    }
  } = getAsset.value ?? {};

  const {
    company = {
      logo: {
        url: ''
      }
    }
  } = owner ?? {};
  const {
    logo = {
      url: ''
    }
  } = company ?? {};
  const { url = '' } = logo ?? {};

  return url;
});
const getAsset = computed(() => {
  return getters['getAsset'];
});
const getCompanyName = computed<string>(() => {
  const {
    owner = {
      company: {
        name: ''
      }
    }
  } = getAsset.value ?? {};
  const {
    company = {
      name: ''
    }
  } = owner ?? {};

  const { name = '' } = company ?? {};
  return name;
});
const getUserName = computed<string>(() => {
  const {
    owner = {
      firstName: '',
      lastName: ''
    }
  } = getAsset.value ?? {};
  const { firstName = '', lastName = '' } = owner ?? {};

  return `${firstName} ${lastName}`;
});
const getPhone = computed<string>(() => {
  const {
    owner = {
      phoneNumber: ''
    }
  } = getAsset.value ?? {};

  const { phoneNumber = '' } = owner ?? {};

  return phoneNumber.length ? Utils.formatPhoneNumber(phoneNumber) : '';
});

// #methods
const onSetRemoteFile = async (
  key: string
): Promise<string | null | undefined> => {
  if (!key) {
    return null;
  }
  try {
    return await getStorageFile(key, {
      level: 'public',
      download: false
    });
  } catch (error) {
    console.error();
  }
};

// #hooks
onMounted(async () => {
  file.value = await onSetRemoteFile(getLogo.value);
});

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!

  return (_openBlock(), _createBlock(AppCardInfo, {
    "card-title": "Customer Information",
    class: "client-info"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (file.value)
          ? (_openBlock(), _createBlock(_component_v_img, {
              key: 0,
              src: file.value,
              alt: "logo",
              loading: "lazy",
              class: "client-info__logo"
            }, null, 8, ["src"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(getUserName.value), 1),
          _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("span", _hoisted_4, _toDisplayString(getCompanyName.value), 1),
          _createElementVNode("span", null, _toDisplayString(getPhone.value), 1)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})